module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9Fau1"))).then(() => parcelRequire('d0iPb'));